var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"oral-locations-map\">\n<div class=\"oral-map-container\">\n<div id=\"locations-map\"></div>\n</div>\n<div class=\"action-section\" ng-if=\"$ctrl.googleMapsUrl\">\n<a class=\"action-link\" ng-href=\"{{$ctrl.googleMapsUrl}}\" target=\"_blank\" translate>\nAvaa Google Mapsissa\n</a>\n</div>\n</div>\n";
var id1="app/locations/locations-map.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/locations/locations-map.tpl.html
// module id = 503
// module chunks = 2